import {
    allFetch
} from "../Domain";

/**
 * @description 施工動作
 */
export const WorkAction = (() => {
    /**
     * @description 施工動作查詢
     */
    const WorkActionSearch = async function (obj = {
        was_type: '',
        was_code: '',
        was_name: '',
        visible: '',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('WorkAction/WorkActionSearch', obj);
    }
    /**
     * @description 施工動作新建
     */
    const WorkActionCreate = async function (obj = {
        was_type: '',
        was_code: '',
        was_name: '',
        note: ''
    }) {
        return await allFetch('WorkAction/WorkActionCreate', obj);
    }
    /**
     * @description 施工動作細項
     */
    const WorkActionDetail = async function (obj = {
        was_id: ''
    }) {
        return await allFetch('WorkAction/WorkActionDetail', obj);
    }
    /**
     * @description 施工動作修改
     */
    const WorkActionUpdate = async function (obj = {
        was_id: '',
        was_type: '',
        was_code: '',
        was_name: '',
        note: '',
        visible: ''
    }) {
        return await allFetch('WorkAction/WorkActionUpdate', obj);
    }
    /**
     * @description 施工動作刪除
     */
    const WorkActionDelete = async function (obj = {
        was_id: '',
    }) {
        return await allFetch('WorkAction/WorkActionDelete', obj);
    }
    return {
        WorkActionSearch,
        WorkActionCreate,
        WorkActionDetail,
        WorkActionUpdate,
        WorkActionDelete
    }
})();